import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { DisplayTypeIdAsset } from "clearline-api";

const ICON_BASE_PATH = "assets/images/device-icons";

/** Sentinel id for the synthetic "All" option (no real {@link DisplayTypeIdAsset} value). */
export const ALL_DEVICE_TYPE_ID = 0;

/** Maps a display-type id ({@link DisplayTypeIdAsset}) to its icon file in `assets/images/device-icons`. */
const DEVICE_ICON_FILE_BY_TYPE_ID: Readonly<Record<number, string>> = {
  [ALL_DEVICE_TYPE_ID]: "all",
  [DisplayTypeIdAsset.TabletHorizontal]: "tablet_hor",
  [DisplayTypeIdAsset.TabletVertical]: "tablet_ver",
  [DisplayTypeIdAsset.DisplayHorizontal]: "dislplay_hor",
  [DisplayTypeIdAsset.DisplayVertical]: "dislplay_ver",
  [DisplayTypeIdAsset.KioskHorizontal]: "kiosk_hor",
  [DisplayTypeIdAsset.KioskVertical]: "kiosk_ver",
  [DisplayTypeIdAsset.TerminalHorizontal]: "terminal_hor",
  [DisplayTypeIdAsset.TerminalVertical]: "terminal_ver"
};

/**
 * Presentational device-type icon keyed by {@link DisplayTypeIdAsset}.
 *
 * The SVG assets are stroke-only, so we render them through a CSS mask driven by
 * `currentColor` — the parent controls the color (muted by default, brand color when
 * selected). Reused by the visual selector and (later) by list/grid/filter columns.
 */
@Component({
  selector: "app-device-type-icon",
  templateUrl: "./device-type-icon.component.html",
  styleUrls: ["./device-type-icon.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceTypeIconComponent {
  readonly typeId = input.required<number>();

  protected readonly maskImage = computed<string>(() => {
    const fileName = DEVICE_ICON_FILE_BY_TYPE_ID[this.typeId()];

    return fileName ? `url("${ICON_BASE_PATH}/${fileName}.svg")` : "none";
  });
}
